(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'toggle',
    function (e) {
      // Desktop-only disclosures. The sort disclosure is the one control that
      // still renders below 64rem, and locking body scroll for it froze the
      // page on mobile for as long as the dropdown was open.
      if (!e.target.classList.contains('filter-disclosure')) return;

      if (e.target.open) {
        document.body.setAttribute('data-scroll-locked', '');
      } else {
        // Unlock scroll only if no other filter is still open
        if (!document.querySelector('.filter-disclosure[open]')) {
          document.body.removeAttribute('data-scroll-locked');
        }
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
